import { useCallback, useEffect, useState } from 'react'
import { GetPlayerCoinHistoryGanamosResponse } from '../../Api/UserPanel/models'
import { getPlayerCoinHistoryGanamos } from '../../Api/UserPanel/UserPanel'


export const useGetPlayerCoinHistoryGanamos = ({ form }: { form: { name: string } }) => {
    const [playerCoinHistory, setPlayerCoinHistory] = useState<GetPlayerCoinHistoryGanamosResponse | null>(null)
    const [loading, setLoading] = useState(false)

    const getCoinHistory = useCallback(async () => {
        setLoading(true)
        const response = await getPlayerCoinHistoryGanamos({ name: form?.name?.trim() })
        setPlayerCoinHistory(response)
        setLoading(false)
    }, [form?.name])

    useEffect(() => {
        if (!form?.name) return;
        getCoinHistory();
    }, [getCoinHistory, form?.name]);

    return {
        playerCoinHistory,
        loading,
        getCoinHistory
    }

}
